// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__Q856J","modal__btn":"Modal_modal__btn__uoyFK","modal__btn_light":"Modal_modal__btn_light__-XKGP"};